import { render } from "./PatientEmergencyContactForm.vue?vue&type=template&id=78834e72&scoped=true"
import script from "./PatientEmergencyContactForm.vue?vue&type=script&lang=js"
export * from "./PatientEmergencyContactForm.vue?vue&type=script&lang=js"

import "./PatientEmergencyContactForm.vue?vue&type=style&index=0&id=78834e72&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78834e72"]])

export default __exports__